import $ from 'jquery';

$(document).ready(function() {
    $('.blogListing').each(function (index, element) {
        const listingSelector = '.listing';
        const listSelector = listingSelector + '__list';
        const itemSelector = listingSelector + '__item';
        const $listing = $(element);
        const $items = $listing.find(itemSelector);
        const $pagination = $listing.find(listingSelector + '__pagination');
        const step = 6;
        let visibleItemsNum = step;

        function render() {
            $items.each(function (index, element) {
                $(element).toggle(index < visibleItemsNum);
            });
            $pagination.toggle( $items.length > visibleItemsNum );
        }

        function showMoreItems() {
            visibleItemsNum = visibleItemsNum + step;
            render();
        }

        render();
        $pagination.on('click', 'button', showMoreItems);
    });
});